import React, { useEffect, useState } from "react";
import StudentsNavbar from "./StudentsNavbar";
import useRole from "../../hooks/useRole";
import {ManagerNavbar} from "./ManagerNavbar";
import { UserRole } from "../../Enums/UserRole";
import { AdminNavbar } from "./AdminNavbar";

export const Navbar = () => {
    const {role} = useRole()

    const [userRole, SetRole] = useState();

    useEffect(() => {
        SetRole(role)
    }, [])

    if (userRole === UserRole.Student) {
        return (
            <StudentsNavbar />
        ) 
    } else if (userRole === UserRole.Manager) {
        return (
            <ManagerNavbar />
        ) 
    }  else if(userRole === UserRole.Admin) {
        return (
            <AdminNavbar />
        )
    } else {
        return null
    }
}